import React, { Component } from 'react';
import { NumberAsCurrency } from '../components/NumberAsCurrency.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow.tsx';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    repaymentAmount: number;
    cashback: number;
    term: number;
    rateType: string;
    rate: number;
    fixedYears: number;
}

export class LenderResult extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        var term = '';
        if (this.props.fixedYears) {
            term = `${this.props.fixedYears} year `;
        }
        var termString = `${term}${this.props.rate}% ${this.props.rateType}`;

        return (
            <header className="App-header">
                <h1 className='l'>We've found a number of options for you.</h1>
                <h2 className='l'>Lowest market rates and monthly repayments <span className='doddltext'>from <NumberAsCurrency value={this.props.repaymentAmount} /></span></h2>
                {this.props.cashback !== 0 && <p>Cashback options of up to <span className='doddltext'><NumberAsCurrency value={this.props.cashback} /></span> are available based on your mortgage amount</p>}
                {/* <p>Rate based on a <strong>{termString}</strong> ... and we have other options worth considering too.</p> */}
                <div className='wrapper'>
                    <div className='row'>
                        <div className='button-group mt-1'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.props.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow showDisclaimer={true} />
                    </div>

                </div>
            </header>
        );
    }
}
